import mitt from 'mitt';
import minstache from './minstache';

export default class AudioPlayer {
  constructor({ template }) {
    // a non-standard way to "extend" from mitt
    Object.assign(this, mitt());

    // private
    this._ext = this._determineCodec();
    this._isMuted = false;
    this._template = template;
    this._tickInterval = null;

    // public
    this.activeSound = null;
    this.sounds = Object.create(null);
  }

  play(slug) {
    if (!this.sounds[slug]) {
      this.addSound(slug);
    }

    const sound = this.sounds[slug];

    // stop any active sounds first
    this.stopAll();

    // then play the selected one
    sound.play();

    // mute it if we're globally muted
    sound.muted = this._isMuted;

    // set it as the active sound
    this.activeSound = sound;

    // start ticking
    clearInterval(this._tickInterval);

    this._tickInterval = setInterval(() => {
      this._tick(slug);
    }, 650);
  }

  mute() {
    if (this.activeSound) this.activeSound.muted = true;

    this._isMuted = true;
    this.emit('mute');
  }

  unmute() {
    if (this.activeSound) this.activeSound.muted = false;

    this._isMuted = false;
    this.emit('unmute');
  }

  stopAll() {
    for (const slug in this.sounds) {
      const sound = this.sounds[slug];

      // stop the audio
      sound.pause();

      // "restart" it
      sound.currentTime = 0;
    }

    clearInterval(this._tickInterval);
  }

  addSound(slug) {
    // we already got this, we're good
    if (this.sounds[slug]) return;

    const filePath = this._compileTemplate(slug);
    const sound = new Audio(filePath);

    sound.addEventListener('ended', () => {
      clearInterval(this._tickInterval);
      this.emit('ended');
    });

    this.sounds[slug] = sound;

    return sound;
  }

  getDurationInMinutes(slug) {
    const sound = this.sounds[slug];
    const duration = Math.round(sound.duration);

    const minutes = Math.floor(duration / 60);
    const seconds = duration - minutes * 60;

    return { minutes, seconds };
  }

  get isMuted() {
    return this._isMuted;
  }

  _tick(slug) {
    const duration = this.activeSound.duration;
    const position = this.activeSound.currentTime;

    this.emit('tick', { duration, position, slug });
  }

  _compileTemplate(slug) {
    return minstache(this._template, { slug, ext: this._ext });
  }

  _determineCodec() {
    let audioTest = null;

    // Must wrap in a try/catch because IE11 in server mode throws an error.
    try {
      audioTest = typeof Audio !== 'undefined' ? new Audio() : null;
    } catch (err) {
      throw new Error('Cannot determine the appropriate codec to use');
    }

    if (!audioTest || typeof audioTest.canPlayType !== 'function') {
      throw new Error('Audio does not have canPlayType, which is weird.');
    }

    if (audioTest.canPlayType('audio/webm')) {
      return 'webm';
    } else if (audioTest.canPlayType('audio/mpeg')) {
      return 'mp3';
    } else {
      throw new Error('No needed codecs are supported.');
    }
  }
}



// WEBPACK FOOTER //
// ./utils/audio-player.js